<template>
  <div class="meeting-info wap-wrapper">
    <TopNotice></TopNotice>
    <header class="banner-container">
      <div
        class="banner-img-container"
        id="video"
        v-show="
          (isLiveStatus && !offsetHide) || isPlayBackStatus || ReplayliveState
        "
      >
        <div v-if="playerType == 'polyv'" class="mudu-video-danmaku"></div>
      </div>
      <div class="wap-video-img" v-show="!isLiveStatus">
        <div class="wap-video-tips">
          <img :src="template.meeting.videoBg.src.value" />
          <!--          <img src="../../assets/images/def-video.png" alt="" />-->
          <!--          <p class="video-tip-txt">感谢您的参与</p>-->
        </div>
      </div>
    </header>
    <div class="toolbar">
      <div class="toolbar-inside">
        <div class="state">
          <span
            class="circle "
            :class="{ blue: !isLiveStatus, red: isLiveStatus }"
          ></span>
          <span v-if="ReplayliveState">回放</span>
          <span v-if="!ReplayliveState">{{ vadioStatus }}</span>
        </div>
        <div class="state" v-if="isShowOnlineNum">
          <span class="online-num">人气：{{ onlineUserNumber }}</span>
        </div>
        <div class="opration">
          <div v-if="webinarInfo.replaySwitch !== 1" class="barrage-box">
            <span
              :class="isBarrage ? 'barrage-on-new' : 'barrage-off-new'"
              @click="toggleBarrage"
            ></span>
          </div>
          <Liner :device="'wap'"></Liner>
          <!--<span class="icontemp shared"></span>-->
          <Like :device="'wap'"></Like>
        </div>
      </div>

      <transition name="ad-slide-up">
        <AdInfo
          v-if="showAd"
          :adInfo="adInfo"
          :adImageInfo="adImageInfo"
          :pctemplate="pctemplate"
          @closeAd="closeAd"
        />
      </transition>
    </div>
    <div class="tabsWrap tabsWrapScrollable">
      <div class="tabsNav tabsNavLine tabsNavComplete">
        <div
          class="tabsTab"
          :style="
            tenantPermInfo.isDisabledInteract == 2 &&
            webinarInfo.replaySwitch !== 1 &&
            !ReplayliveState
              ? ''
              : { display: 'none' }
          "
          @click="didClicKTab(0)"
        >
          <span class="tabText" :class="TabCur == 0 ? 'tabActive' : ''"
            >评论</span
          >
        </div>
        <div
          class="tabsTab"
          :style="
            webinarInfo.replaySwitch == 1 || ReplayliveState
              ? ''
              : { display: 'none' }
          "
          @click="didClicKTab(1)"
        >
          <span class="tabText" :class="TabCur == 1 ? 'tabActive' : ''"
            >更多回放</span
          >
        </div>
        <div
          class="tabsTab"
          :style="ReplayliveState || pptIsOpen ? '' : { display: 'none' }"
          @click="didClicKTab(2)"
        >
          <span class="tabText" :class="TabCur == 2 ? 'tabActive' : ''"
            >文档</span
          >
        </div>
        <div
          class="tabsTab"
          v-if="template.meeting.tab_1_p.display.value"
          @click="didClicKTab(3)"
        >
          <span class="tabText" :class="TabCur == 3 ? 'tabActive' : ''">{{
            template.meeting.tab_1_p.text.value
          }}</span>
        </div>
        <div
          class="tabsTab"
          v-if="template.meeting.tab_2_p.display.value"
          @click="didClicKTab(4)"
        >
          <span class="tabText" :class="TabCur == 4 ? 'tabActive' : ''">{{
            template.meeting.tab_2_p.text.value
          }}</span>
        </div>
        <div
          class="tabsTab"
          v-if="template.meeting.tab_3_p.display.value"
          @click="didClicKTab(5)"
        >
          <span class="tabText" :class="TabCur == 5 ? 'tabActive' : ''">{{
            template.meeting.tab_3_p.text.value
          }}</span>
        </div>
        <div
          class="tabsTab"
          v-if="template.meeting.tab_4_p.display.value"
          @click="didClicKTab(6)"
        >
          <span class="tabText" :class="TabCur == 6 ? 'tabActive' : ''">{{
            template.meeting.tab_4_p.text.value
          }}</span>
        </div>
      </div>
    </div>
    <div class="tabsBlock">
      <div class="tabsBox" v-show="TabCur == 0">
        <template v-if="webinarInfo.replaySwitch !== 1 && !ReplayliveState">
          <Discuss></Discuss>
        </template>
      </div>
      <div class="tabsBox" v-show="TabCur == 1">
        <template>
          <VideoLists
            v-if="webinarInfo.replaySwitch == 1 || ReplayliveState"
          ></VideoLists>
        </template>
      </div>
      <div class="tabsBoxPpt" id="pptDom">
        <template>
          <Document ref="ppt"></Document>
        </template>
      </div>
      <div class="tabsBox" v-show="TabCur == 3">
        <template>
          <Info v-if="template.meeting.tab_1_p.display.value"></Info>
        </template>
      </div>
      <div class="tabsBox" v-show="TabCur == 4">
        <template>
          <agenda v-if="template.meeting.tab_2_p.display.value"></agenda>
        </template>
      </div>
      <div class="tabsBox" v-show="TabCur == 5">
        <template>
          <GuestInfo v-if="template.meeting.tab_3_p.display.value"></GuestInfo>
        </template>
      </div>
      <div class="tabsBox" v-show="TabCur == 6">
        <template>
          <Expand v-if="template.meeting.tab_4_p.display.value"></Expand>
        </template>
      </div>
    </div>

    <Interaction v-if="tenantPermInfo.isDisabledVoteQueDown == 2"></Interaction>
    <Lottery></Lottery>
    <File></File>
  </div>
</template>

<script>
import $ from "jquery";
import { tenantId, instanceId, webinarId } from "../../common/sbase";
import Info from "../../components/wap/Info";
import Agenda from "../../components/wap/Agenda";
import GuestInfo from "../../components/wap/GuestInfo";
import Interaction from "../../components/wap/Interaction";
import AdInfo from "../../components/wap/AdInfo";
import { $subscriber, ck, cr, URLS } from "fire-wind-water";
import { onKickOut, validateState } from "@/common/joinMeeting";
import { joinMett, goToSignUp } from "@/common/joinMeeting";
import URL from "../../assets/conf/setting.json";
import { socketModule } from "../../common/socket";
import webinarService from "../../services/webinar";
import user from "../../common/user";
import Document from "../../components/wap/Document";
import Discuss from "../../components/wap/Discuss";
import TopNotice from "../../components/wap/TopNotice.vue";
import Lottery from "../../components/wap/Lottery.vue";
import Expand from "../../components/wap/Expand.vue";
import File from "../../components/wap/File";
import Like from "../../components/pc/Like";
import Liner from "../../components/pc/Line";
import { mixinsTemplate } from "../../common/mixinsTemplate";
import DanmuJs from "@/common/danmu";
import { replaceColon } from "@/common/emoji";
import VideoLists from "../../components/wap/VideoLists";
import longVariable from "../../common/longVariable";
import comonService from "../../services/comonService";

export default {
  name: "wapMeeting",
  mixins: [mixinsTemplate],
  data() {
    return {
      options: {},
      isLiveStatus: false,
      vadioStatus: "暂无直播",
      isShowOnlineNum: false,
      onlineUserNumber: "",
      webinarInfo: {},
      userInfo: {},
      bannerImgUrl: "",
      isBarrageInit: false,
      isBarrage: false,
      isVisible: true,
      tabLineWidth: "40px",
      tabsIndex: 0,
      danmu: null,
      pptIsOpen: false,
      isHavePpt: false, //当前播放的 视频 有没有ppt 文档
      isMuduReady: false,
      isPptInit: false,
      isMobile: !!navigator.userAgent.match(
        /(iPhone|iPod|Android|ios|HarmonyOS|OpenHarmony)/i
      ),
      showAd: false,
      adList: [],
      adInfo: {},
      adImageInfo: [],
      schemaId: "",
      tenantId: "",
      isPlayBackStatus: false, //视频模块回放状态
      ReplayliveState:
        window.location.href.indexOf("liveState=replay") > -1 &&
        window.location.href.indexOf("isSetting=1") > -1
          ? true
          : false, //静态链接回放状态
      player: null,
      TabCur: 1, //tab 默认选择
      playerType: "" //播放器 类型
    };
  },
  computed: {
    offsetHide() {
      return this.$store.state.offsetHide;
    }
  },
  methods: {
    skInit() {
      this.tenantId = window.$sk.template.get().common.tenantId;
      this.schemaId = window.$sk.template.get().common.schemaId;
      this.init();
      this.bannerImgUrl = require("@/assets/images/video.jpg");
      this.getUserInfo();
    },
    init() {
      if (window.location.href.indexOf("isSetting") > -1) {
        this.didClicKTab(1);
      }
      let _this = this;
      window.$sk.webinar.module({
        //播放器状态
        skPlayerStatus(res) {
          let data = res[0];
          if (data.content.data == "直播回放") {
            _this.vadioStatus = data.content.data;
            _this.isPlayBackStatus =
              data.content.data == "直播回放" ? true : false;
            _this.isLiveStatus = data.content.data == "直播回放" ? true : false;
          } else {
            $subscriber.emit("onVideoStatus", data); //发布播放器是回放状态
          }
        },
        //ppt发生改变
        skPptInfoChange(res) {
          let data = res[0];
          let { pptIsOpen, isHavePpt } = data;
          _this.pptIsOpen = pptIsOpen;
          _this.isHavePpt = isHavePpt;
          if (_this.webinarInfo.webCastProvider == "polyv") {
            if (!_this.webinarInfo.isPolyvHavePpt) {
              _this.pptIsOpen = false;
            }
          }
          if (_this.webinarInfo.replaySwitch == 1) {
            if (!pptIsOpen) {
              _this.didClicKTab(1);
            }
          } else {
            if (!pptIsOpen) {
              _this.didClicKTab(0);
            }
          }
        },
        //监听： 视频播放
        skPlayer(res) {
          let videoStatus = res[0];
          //开始 链接 soket
          if (socketModule.isOn == null) {
            socketModule.init(URL.webinarbInteractUrl + "center", null);
            socketModule.connect(_this.userInfo, _this.webinarInfo, function() {
              _this.logPlayStart();
            });
          } else {
            _this.logPlayStart();
          }
          $subscriber.emit("playerButtonStatus", videoStatus);
        },
        //监听： 视频暂停
        skStoped(res) {
          let videoStatus = res[0];
          _this.logPlayStop();
          if (socketModule.isOn !== null) {
            socketModule.disconnect_connect();
            $subscriber.emit("playerButtonStatus", videoStatus);
          }
        },
        //监听： 视频结束
        skEnded(res) {
          let videoStatus = res[0];
          _this.logPlayStop();
          if (socketModule.isOn !== null) {
            socketModule.disconnect_connect();
            $subscriber.emit("playerButtonStatus", videoStatus);
          }
        },
        //监听： 视频切换
        skSdkVideoChangeUrl(res) {
          $subscriber.emit("simulateClickEvent", res[0]);
        },
        // 监听 播放器初始化
        skPlayerInit(res) {
          _this.isMuduReady = true;
          _this.initDanmu();
        }
      });
      $subscriber.subscribe("webinarInfo.meeting", data => {
        this.webinarInfo = data;
        window.$sk.webinar.skUserEvent({
          type: "userCanJoin",
          data: this.webinarInfo
        });
        this.vadioStatus = data.replaySwitch == 1 ? "暂无回放" : "暂无直播";
        this.playerType = data.webCastProvider;
        if (data.replaySwitch !== 1) {
          this.didClicKTab(0);
        }
        webinarService
          .getLiveLimit({
            tenantId: tenantId,
            webinarId: data.webinarId
          })
          .then(res => {
            if (!res.allowEnter) {
              window.$sk.goto(
                "//s2-cdn.smarket.net.cn/public/limit/" +
                  "wap-information.html" +
                  "?msg=" +
                  encodeURIComponent(res.reminder) +
                  "&returnUrl=" +
                  encodeURIComponent(
                    window.location.href.replace("meeting", "meetingInfo")
                  )
              );
              return;
            }
          });
        //是否显示红包入口
        if (
          !this.webinarInfo.unLimit &&
          this.tenantPermInfo.isDisabledRedPacket == "2"
        ) {
          setTimeout(() => {
            window.$redEnvelope.init({
              type: "wap",
              tenantId: tenantId,
              instanceId: instanceId
            });
          }, 500);
        }
        this.adList = data.adList;
        cr.each(this.adList, list => {
          if (list.adDevice == "wap") {
            if (list.adType == "2") {
              this.adInfo = list;
            } else {
              this.adImageInfo.push(list);
            }
          }
        });
        let ck_isBarrage = ck.cookie("isBarrage_" + this.webinarInfo.webinarId);
        if (ck_isBarrage) {
          this.isBarrage = ck_isBarrage;
        }
        //直接改url进入 meeting页 判断 用户状态
        setTimeout(() => {}, 2000);
        let tenantId = URLS.getURL("tenantId");
        const apiUrl = URL.template.api.gateway.general;
        let isWeChatBrowser =
          navigator.userAgent.toLowerCase().indexOf("micromessenger") > -1;
        if (isWeChatBrowser) {
          window.$swxsdk.initWxSdk({ tenantId }, apiUrl);
          let coverImageUrl =
            data.weChatId && data.shareCoverUrl
              ? data.shareCoverUrl.replace("http://", "https://")
              : "https:" + data.logoRealPath;
          try {
            if (cr.isEmptyObject(data.title) === false)
              if (data.canShare != 1) {
                window.$swxsdk.on(
                  "hideMenuList",
                  {
                    menuList: [
                      "menuItem:share:appMessage",
                      "menuItem:share:timeline",
                      "menuItem:share:qq",
                      "menuItem:share:weiboApp",
                      "menuItem:share:facebook",
                      "menuItem:share:QZone"
                    ]
                  },
                  function(result) {
                    console.log(result);
                  }
                );
                return;
              }

            window.$swxsdk.on(
              "sharer",
              {
                title:
                  data.weChatId && data.shareTitle
                    ? data.shareTitle
                    : data.title, // 分享标题
                desc:
                  data.weChatId && data.shareSummary
                    ? data.shareSummary
                    : data.title, // 分享描述
                link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: coverImageUrl // 分享图标
              },
              function(result) {
                console.log(result);
              }
            );
            window.$swxsdk.on(
              "sharer_friends",
              {
                title:
                  data.weChatId && data.shareTitle
                    ? data.shareTitle
                    : data.title, // 分享标题
                desc:
                  data.weChatId && data.shareSummary
                    ? data.shareSummary
                    : data.title, // 分享描述
                link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: coverImageUrl // 分享图标
              },
              function(result) {
                console.log(result);
              }
            );
          } catch (e) {
            console.log(e);
          }
        }
      });
      $subscriber.subscribe("userInfo", data => {
        this.userInfo = data;
        if (this.adList) {
          cr.each(this.adList, item => {
            if (
              !ck.cookie("user_ad_" + this.userInfo.id) &&
              item.adDevice == "wap" &&
              this.pctemplate.meeting &&
              ((item.adType == "2" &&
                item.adContent &&
                this.pctemplate.meeting.ad.display.value) ||
                (item.adType == "1" &&
                  this.pctemplate.meeting.adimage.display.value))
            ) {
              this.showAd = true;
            }
          });
        }
      });
      $subscriber.subscribe("onLoginMeeting", () => {
        if (!this.webinarInfo.unLimit) {
          if (this.webinarInfo.needLogin && !this.userInfo.isLogin) {
            //未登录
            window.$sk.loading.hide();
            $subscriber.emit("showPopup", {
              message: "很抱歉，登录成功才能进入本场会议。"
            });
            setTimeout(() => {
              joinMett(this.webinarInfo, this.userInfo);
            }, 1000);
          }
        }
      });
      $subscriber.subscribe("onSignUpMeeting", () => {
        if (!this.webinarInfo.unLimit) {
          if (this.webinarInfo.needLogin && !this.userInfo.isLogin) {
            return false;
          }
          if (!this.userInfo.isRegistration) {
            //未报名
            if (this.webinarInfo.needRegistration) {
              window.$sk.loading.hide();
              // 去常规报名
              $subscriber.emit("showPopup", {
                message: "很抱歉，报名成功才能进入本场会议。"
              });
              //延迟3秒跳转
              setTimeout(() => {
                goToSignUp(this.webinarInfo, jumpUrl => {
                  window.$sk.goto(jumpUrl);
                });
              }, 500);
            }
          }
        }
      });
      $subscriber.subscribe("changeScreenStatus", () => {
        this.screenStatus = !this.screenStatus;
      });
      $subscriber.subscribe("change-line-stream", i => {
        this.changeLineStream(i.file);
      });

      $subscriber.subscribe("onVideoStatus", data => {
        this.vadioStatus =
          data.content.data == "直播" ? "正在直播" : "暂无直播";
        this.isLiveStatus = data.content.data == "直播" ? true : false;
      });
      $subscriber.on("onKickout", data => {
        this.userInfo.hasPermission = false;
        onKickOut(data.reason);
      });
      $subscriber.on("kickOut", data => {
        onKickOut(data);
      });
      $subscriber.subscribe("onMuDuPlayerReady", () => {
        this.isMuduReady = true;
        this.initDanmu();
      });
      $subscriber.subscribe("onQAGet", qa => {
        let isSelf = this.userInfo.applicantId == qa.from_user.uid;
        let message = replaceColon(qa.content);
        if (qa.from_user.role == 0) {
          this.addDanmu({ id: qa._id, message, isSelf });
        }
      });
      $subscriber.subscribe("toggleNotifyStatus", isShowNotify => {
        $(".mudu-video-danmaku").css({
          top: isShowNotify ? $(".top-notice").height() : 0
        });
      });
      //只执行一次因为是单页面应用 如果是 on的话
      // 监听了两边（观看页一遍 踢出再进来又一遍） 也会执行两遍
      $subscriber.onic("onPublishGrabRedPacket", data => {
        if (data.length > 0) {
          data = data[0];
        }
        data.type = "wap";
        data.schemaId = this.schemaId;
        data.tenantId = this.tenantId;
        if (
          !this.webinarInfo.unLimit &&
          this.tenantPermInfo.isDisabledRedPacket == "2"
        ) {
          window.$redEnvelope.find({
            type: data.type,
            weChatId: data.weChatId,
            luckyDrawId: data.id,
            schemaId: data.schemaId,
            tenantId: data.tenantId,
            instanceId: data.instanceId,
            logoUrl: data.logoUrl,
            luckyName: data.luckyName, //红包名称
            rpBlessings: data.rpBlessings, //祝福语，
            rpBusinessName: data.rpBusinessName
          });
        }
      });

      $subscriber.subscribe("onUserOnlineNum", data => {
        this.isShowOnlineNum = data.show ? true : false;
        this.onlineUserNumber = data.num;
      });
      $subscriber.subscribe("showWapshowAd", data => {
        this.showAd = true;
      });
      window.$sk.webinar.module({
        skMeetingLinkEnd() {
          const info = window.$sk.webinar.get().meetingInfo;
          const webianr = Object.assign(_this.webinarInfo, info);
          const userInfo = window.$sk.webinar.get().user;
          if (!validateState(webianr, userInfo)) {
            //状态不对  返回 meetingInfo
            if (window.location.href.indexOf("meetingInfo") == -1) {
              let returnUrl = window.location.href.replace(
                "/meeting",
                "/meetingInfo"
              );
              setTimeout(() => {
                window.$sk.goto(returnUrl);
              }, 1000);
            }
          }
          _this.socketInit();
        },
        skPolyvNews(data) {
          if (data && data[0] && data[0].content.type == "switchMainScreen") {
            $subscriber.emit("switchMainScreen", data[0].content.data);
          } else if (data && data[0] && data[0].content.type == "taboo") {
            webinarService.gagTrue({
              uid: _this.userInfo.id,
              webinarId: webinarId,
              globalUserId: ck.cookie("globalUserId") || ""
            });
          } else if (
            data &&
            data[0] &&
            data[0].content.type == "recoveryTaboo"
          ) {
            webinarService.gagFalse({
              uid: _this.userInfo.id,
              webinarId: webinarId,
              globalUserId: ck.cookie("globalUserId") || ""
            });
          } else if (data && data[0] && data[0].content.type == "kickout") {
            webinarService.kickout({
              uid: _this.userInfo.id,
              webinarId: webinarId,
              tenantId: tenantId,
              globalUserId: ck.cookie("globalUserId") || ""
            });
          }
        }
      });
      window.addEventListener("resize", resize => {
        setTimeout(() => {
          if (this.webinarInfo.replaySwitch == 1) {
            this.didClicKTab(this.TabCur);
          } else {
            this.didClicKTab(this.TabCur);
          }
        }, 50);
      });
      // this.pushHistory();
      window.addEventListener("popstate", this.popstateReload, false);
    },
    socketInit() {
      //若果是回看  不用出现临时用户弹窗
      if (this.webinarInfo.replaySwitch !== 1) {
        this.showUserNameDialog();
      }
      if (socketModule.isOn == null) {
        let userInfo = window.$sk.webinar.get().user;
        let webinarInfo = this.webinarInfo;
        socketModule.init(URL.webinarbInteractUrl + "center", null);
        //console.log("%c 开始链接socket", "color:#0f0;");
        socketModule.connect(userInfo, webinarInfo);
        //console.log("%c 结束链接socket", "color:red;");
      }
      if (this.webinarInfo.replaySwitch !== 1) {
        window.$sk.webinar.skSdkEvent({
          type: "init",
          data: {
            webcastId: this.webinarInfo.webcastId,
            videoBg: this.template.meeting.videoBg.src.value,
            type: "live",
            webCastProvider: this.webinarInfo.webCastProvider,
            tenantId: this.webinarInfo.tenantId
          }
        });
      }
    },
    logPlayStart() {
      let _this = this;
      comonService.logPlayStart({
        id: _this.userInfo.id,
        socketId: socketModule.socket.id,
        tenantId: _this.webinarInfo.tenantId,
        webinarId: _this.webinarInfo.webinarId,
        globalUserId: ck.cookie("globalUserId")
      });
    },
    logPlayStop() {
      let _this = this;
      comonService.logPlayStop({
        id: _this.userInfo.id,
        socketId: socketModule.socket.id,
        tenantId: _this.webinarInfo.tenantId,
        webinarId: _this.webinarInfo.webinarId,
        globalUserId: ck.cookie("globalUserId")
      });
    },
    closeAd() {
      this.showAd = false;
      $subscriber.emit("hideWapshowAd", this.userInfo);
    },
    getUserInfo() {},
    popstateReload() {
      window.location.reload();
    },
    pushHistory() {
      var state = { title: "呵呵哒", url: "#" };
      window.history.pushState(state, "新页面标题#", window.location.href);
    },
    validateWebinarState() {
      if (!this.webinarInfo.isReleased) {
        //会场未发布
        onKickOut("很抱歉，会场未发布");
      } else if (this.webinarInfo.isClosed) {
        if (this.webinarInfo.replaySwitch === 1) {
        } else {
          //会场已关闭
          if (this.webinarInfo.demandUrl) {
            // 已转点播
            window.$sk.goto(this.webinarInfo.demandUrl);
          } else {
            onKickOut("很抱歉，您来晚了，本场会议已经关闭");
          }
        }
      } else if (!this.webinarInfo.isOpen) {
        //会场未开放
        onKickOut("会场尚未开放，请您稍后再来", this.webinarInfo);
      }
    },
    showUserNameDialog() {
      //无限制观看，未登录报名，未设置用户名
      if (
        this.webinarInfo.unLimit &&
        this.webinarInfo.isSetUserName &&
        this.userInfo.temporaryUserName == ""
      ) {
        if (
          !this.userInfo.isLogin &&
          (!this.userInfo.isRegistration ||
            (this.userInfo.isRegistration && this.userInfo.isUnLimit))
        ) {
          $subscriber.emit("showSetUserName", true);
        } else {
          $subscriber.emit("showSetUserName", false);
        }
      }
    },

    toggleBarrage() {
      if (!this.isBarrageInit) {
        $subscriber.emit("showPopup", {
          message: "不要着急，请稍后操作。",
          delay: 2000
        });
        return;
      }
      this.isBarrage = !this.isBarrage;
      ck.cookie("isBarrage_" + this.webinarInfo.webinarId, this.isBarrage, {
        expires: 1,
        domain: window.$sk.config.domain,
        path: "/"
      });
      if (this.isBarrage) {
        this.danmu.start();
      } else {
        this.danmu.stop();
        this.isBarrageInit = false;
        setTimeout(() => {
          this.isBarrageInit = true;
        }, 250);
      }
    },

    initDanmu() {
      this.danmu = new DanmuJs({
        container: document.querySelector(".mudu-video-danmaku"),
        containerStyle: {
          height: "50px"
        },
        channelSize: 25
      });
      this.isBarrageInit = true;

      document.addEventListener("visibilitychange", () => {
        this.isVisible = document.visibilityState === "visible";
      });
    },

    /**
     * 发送弹幕
     * @param id 唯一标识
     * @param message 弹幕内容
     * @param isSelf 是否为自己发送（会特殊标记）
     */
    addDanmu({ id, message, isSelf }) {
      if (!this.isBarrageInit) return;
      if (!this.isBarrage) return;
      if (!this.isVisible) return;
      let messageBox = $(
        `<div class="${
          isSelf ? "danmu-mess self" : "danmu-mess"
        }">${message}</div>`
      );
      this.danmu.sendComment({
        id: id + "",
        duration: 10000,
        noDiscard: true,
        noDiscardFirst: true,
        isFirst: isSelf,
        el: messageBox.get(0)
      });
    },
    didClicKTab(idx) {
      this.TabCur = idx;
      let ppt = document.getElementById("pptDom");
      if (idx == 2) {
        if (ppt) {
          ppt.style.zIndex = 10;
        }
      } else if (idx == 5) {
        $subscriber.emit("showGuestLists", true);
      } else {
        if (ppt) {
          ppt.style.zIndex = -10;
        }
      }
    }
  },
  created() {
    window.$sk.template.module(this);

    // this.init();
    this.bannerImgUrl = require("@/assets/images/video.jpg");
    this.getUserInfo();
  },
  mounted() {},
  updated() {},
  beforeDestroy() {
    $subscriber.off("initSkSDK");
    console.log("%c 开始销毁socket", "color:#0f0;");
    socketModule.disconnect();
    console.log("%c 结束销毁socket", "color:red;");
    ///销毁目睹
    window.$sk.webinar.skSdkEvent({ type: "remove", data: {} });
    window.$redEnvelope.destroy();
    window.removeEventListener("popstate", this.popstateReload);
  },
  components: {
    Info,
    Agenda,
    GuestInfo,
    Interaction,
    Document,
    Discuss,
    TopNotice,
    Lottery,
    Expand,
    File,
    Like,
    Liner,
    VideoLists,
    AdInfo
  }
};
</script>

<style lang="scss"></style>
